// React for Website

import React from "react";
//outsource
import { Row, Col, List } from "antd";

//components
import VoucherCard from "./voucher_card";

const VoucherList = ({ data, setOpen, setSelected }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <List
      dataSource={data || []}
      style={{ marginTop: 20 }}
      itemLayout="vertical"
      bordered
      pagination={{
        pageSize: 10,
      }}
      grid={{ column: 1 }}
      renderItem={(item) => {
        return (
          <VoucherCard
            data={item}
            setOpen={setOpen}
            setSelected={setSelected}
          />
        );
      }}
    />
  );
};

export default VoucherList;
